<script setup lang='ts'>
import { isFunction, numFormat } from '@qcwp/utils'
import { tabbarDetailDefault } from '~~/src/components/layout/tabbar/hooks/detail'
import type { ArticleCommentParams } from '~~/src/server/modules/article/type'
import { useAuth } from '~~/src/store'

const props = withDefaults(defineProps<{
  poster?: boolean
  articleId: string
  placeholder?: boolean
  isFavor?: boolean // 是否点赞
  isStar?: boolean // 是否收藏
  favorCount?: number // 文章点赞数
  starCount?: number // 文章收藏数
  commentCount?: number // 文章评论数
  param: Omit<ArticleCommentParams, 'pageSize' | 'pageNum'>
  onCommentClickHandle?: () => void
}>(), {
  poster: true,
  articleId: '',
  placeholder: true,
  ...tabbarDetailDefault,
})
const emits = defineEmits({
  starHandle: () => true,
  commentClickHandle: () => true,
})

// 展示评论列表
const commentListShow = ref(false)
function commentClickHandle() {
  if (props.onCommentClickHandle && isFunction(props.onCommentClickHandle))
    props.onCommentClickHandle()
  else
    commentListShow.value = true
}
// 评论输入款
const inputShow = ref(false)

const authStore = useAuth()
function commentInputHandle() {
  if (authStore.checkIsLogin())
    inputShow.value = true
}
</script>

<template>
  <div v-if="props.placeholder" class="detail-tabbar__placeholder safe-area-bottom" />
  <div class="detail-tabbar px-4 pt-2 safe-area-bottom">
    <div class="flex items-center gap-2 h-full pb-2 w-full">
      <div class="input" @click="commentInputHandle">
        说点什么...
      </div>
      <layout-comment-tabbar-input v-model:show="inputShow" :article-id="props.articleId" />
      <div class="flex-shrink-0" grid="~ cols-3" gap-4>
        <!-- TODO: 点赞 -->
        <!-- <n-badge :value="numFormat(favorCount)" :max="99" color="#D1D5DB">
        <button class="item">
          <i class="i-icon-park-solid:good-two" :class="{ 'text-yellow-300': props.isFavor }" />
        </button>
      </n-badge> -->
        <n-badge :value="numFormat(commentCount)" color="#D1D5DB">
          <button class="item" @click="commentClickHandle">
            <i class="i-fluent:comment-28-filled" />
          </button>
          <layout-comment-tabbar-list v-model:show="commentListShow" :param="props.param" />
        </n-badge>
        <n-badge color="#D1D5DB">
          <button class="item" :class="{ 'item-active': props.isStar }" @click="emits('starHandle')">
            <i class="i-clarity:star-solid" />
          </button>
        </n-badge>
        <layout-tabbar-share :poster="props.poster" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .item {
    --uno: w-8 h-8 text-5 text-title-400;

    &-active {
      --uno: text-yellow-400;
    }
  }

  .input {
    --uno: flex-grow w-0 bg-gray-100 text-title-400 h-8.5 leading-8.5  rounded-full px-3;
  }

  .detail-tabbar {
    --uno: fixed z-99 bottom-0 left-0 w-full min-h-13 bg-white border-t-1 border-gray-200;
  }

  .detail-tabbar__placeholder {
    --uno: w-full min-h-13 bg-white;
  }
</style>
